import { Button, Form, Input, Checkbox, Space, message } from 'antd'
import { useState, useRef, Fragment, useImperativeHandle, useEffect } from 'react'
import User from '@/modules/user'
import CountDownBtn from '@/components/countDownBtn'
import Protocol from './Protocol'
import Privacy from './Privacy'
import styles from './register.scss'
import { isMobileAgent } from '@/utils/utils'
import { SYSCON } from '@/const/const.js'

const RegisterForm = (props) => {
  // 属性
  const formRef = useRef()
  const { handleModalClose } = props
  const [proModalVisible, handleProVisible] = useState(false)
  const [privacyModalVisible, handlePrivacyVisible] = useState(false)
  const [checked, handlCheck] = useState(false)

  // 用户初始化
  const user = new User()
  const [inviterCode, setInviterCode] = useState(null)
  // 用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(props.onRef, () => {
    return {
      open
    }
  })
  const open = () => {
    console.log('props.code', props.code)
    if (props.code) {
      setInviterCode(props.code)
    }
  }
  // 初始化
  useEffect(()=>{
    open()
  }, [])
  const onChange = e => {
    console.log('checked = ', e.target.checked)
    handlCheck(e.target.checked)
  }
  // 注册请求
  const handleRegister = async(fields) => {
    // 加载信息
    const hide = message.loading('正在注册')
    try {
      const data = { ...fields }
      if (inviterCode) {
        data.inviterCode = inviterCode
      }
      console.log('dd', data)
      const srcCd = isMobileAgent() ? SYSCON.UserSrcOfficWebMobile : SYSCON.UserSrcOfficWebPC
      console.log(srcCd, isMobileAgent(), 'srcCd')
      await user.register(data, srcCd)
      hide()
      message.success('注册成功')
      return true
    } catch (error) {
      hide()
      console.log('error', error)
    }
  }
  // 处理注册
  const onFinish = async(values) => {
    console.log('value', values)
    const result = await handleRegister({ ...values })

    if (result) {
      handleModalClose()
    }
  }

  const handleSend = () => {
    const { phone } = formRef.current.getFieldsValue(true)
    return checkPhoneValue(phone).then(()=>{
      user.sendCode({ phone })
      return Promise.resolve()
    }).catch((err)=>{
      return Promise.reject(err)
    })
  }

  const passwordValid = ({ getFieldValue }) => ({
    validator(_, value) {
      const cnReg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
      if (cnReg.test(value)) {
        return Promise.reject(new Error('密码不能为中文'))
      }
      if (!value || getFieldValue('password') === value) {
        return Promise.resolve()
      }
      return Promise.reject(new Error('两次输入密码不一致!'))
    }
  })

  const phoneValid = () => ({
    validator(_, value) {
      return checkPhoneValue(value)
    }
  })

  const validatePwd = () => ({
    validator(_, value) {
      if (value) {
        const reg = new RegExp('^(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)\\S+$')
        const cnReg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
        if (value && (value.length < 8 || value.length > 35)) {
          return Promise.reject(new Error('请输入8到35位的密码'))
        }
        if (!(reg.test(value)) || (cnReg.test(value))) {
          return Promise.reject(new Error('密码需数字、字母小写、字母大写、字符两种及以上组合'))
        } else {
          return Promise.resolve()
        }
      } else {
        return Promise.reject('请输入密码')
      }
    }
  })

  const validateVcode = () => ({
    validator(_, value) {
      if (value) {
        const cnReg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
        if ((cnReg.test(value))) {
          return Promise.reject(new Error('验证码不能为中文'))
        } else {
          return Promise.resolve()
        }
      } else {
        return Promise.reject('验证码不能为空')
      }
    }
  })

  const checkPhoneValue = async(value)=>{
    if (['', undefined].includes(value)) {
      return Promise.reject(new Error('请输入手机号!'))
    }
    if (value && value.length !== 11) {
      return Promise.reject(new Error('请输入11位的手机号!'))
    }
    if (!Number.isInteger(value - 0)) {
      return Promise.reject(new Error('请输入正确格式的手机号!'))
    }

    const phoneResult = await user.checkPhone({ phone: value })
    if (phoneResult) {
      return Promise.reject(new Error('手机号已注册'))
    } else {
      return Promise.resolve()
    }
  }

  const cnInputCheck = (event) => {
    return event.target.value.replace(/[\u4E00-\u9FA5]/g, '').replace(/\s/g, '')
  }

  return (
    <Fragment>

      <Form
        ref={formRef}
        onFinish={onFinish}
        name='normal_register'
        className={styles['login-form']}
      >
        <Form.Item
          name='nm'
          rules={[{ required: true, message: '姓名不能为空' }]}
        >
          <Input prefix={'姓名'} />
        </Form.Item>
        <Form.Item
          name='phone'
          rules={[
            phoneValid
          ]}
          getValueFromEvent={(e) => e.target.value.trim()}
        >
          <Input prefix={'手机号'} />
        </Form.Item>
        <Form.Item
          name='password'
          rules={[
            validatePwd
          ]}

          getValueFromEvent = {cnInputCheck}
        >
          <Input.Password onCopy={(e) => e.preventDefault()} placeholder='请输入8-35位字符新密码' prefix={'密码'}/>

        </Form.Item>
        <Form.Item
          name='cPassword'
          rules={[
            passwordValid
          ]}
          getValueFromEvent = {cnInputCheck}
        >
          <Input.Password
            onCopy={(e) => e.preventDefault()}
            prefix={'确认密码'}
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <Form.Item
            name='code'
            rules={[validateVcode]}

            style={{ display: 'inline-block', width: 'calc(74% - 8px)' }}
            getValueFromEvent = {cnInputCheck}
          >
            <Input onCopy={(e) => e.preventDefault()} placeholder='请输入验证码' />
          </Form.Item>
          <Form.Item
            style={{ display: 'inline-block', width: 'calc(26% - 8px)', margin: '0 8px' }}
          >
            <CountDownBtn handleSend={handleSend}/>
          </Form.Item>
        </Form.Item>
        <Form.Item>
          <Checkbox checked={checked} onChange={onChange} /> 已阅读并同意 <a onClick={() => handleProVisible(true)}>《用户协议》</a>和 <a onClick={() => handlePrivacyVisible(true)}>《用户隐私》</a>
        </Form.Item>

        <Form.Item>
          <div className={styles['btns']}>
            <Space >
              <Button onClick={() => handleModalClose()} >
             取消
              </Button>
              <Button disabled={!checked} type='primary' htmlType='submit' >
             注册
              </Button>
            </Space>
          </div>

        </Form.Item>
      </Form>
      <Protocol modalVisible={proModalVisible} onCancel={() => handleProVisible(false)}/>
      <Privacy modalVisible={privacyModalVisible} onCancel={() => handlePrivacyVisible(false)}/>
    </Fragment>
  )
}

export default RegisterForm
